export class SolutionSinglePage {
	constructor() {
		this.registerEventListeners();
	}

	registerEventListeners() {
		const $relatedSolutions = jQuery(
			'body.single-solution .related-solutions .ecs-posts'
		);
		if ($relatedSolutions.length) {
			$relatedSolutions.on('scroll', (e) =>
				this.relatedSolutionsScrollHandler(e)
			);
		}
	}

	relatedSolutionsScrollHandler(e) {
		const target = e.target;
		const $container = jQuery(target);
		const $solutionSections = $container.find('article .elementor-section');

		$solutionSections.each((index, solutionSection) => {
			const $solutionSection = jQuery(solutionSection);
			if ($solutionSection.css('visibility') === 'hidden') {
				$solutionSection.css('visibility', 'visible');
			}
		});
	}
}
